module.exports = __webpack_public_path__ + "static/media/blogssdef.f7c3e04d.jpg";